import { PagerSettings, SelectableSettings, SortSettings } from '@progress/kendo-angular-grid';

export const PAGER_OPTIONS: PagerSettings = {
  buttonCount: 5,
  info: true,
  type: 'input',
  pageSizes: [10, 25, 50, 100, 250, 500, 1000],
  previousNext: true,
  position: 'bottom',
};

export const PAGER_SIZE = 25;

export const SORT_SETTINGS: SortSettings = {
  mode: 'multiple',
  allowUnsort: true,
};

/**
 * Выделение строго одной строки: в режиме multiple Ctrl/Shift добавляют
 * несколько записей, а тулбары разделов работают с одной выбранной.
 */
export const SELECT_SETTINGS: SelectableSettings = {
  mode: 'single',
};
